import m from 'mithril'
import { home, question } from '../../lib/icons'

export default function accessDialog (options, ...children) {
  return m('.access-dialog',
    m('.text-center.mb-2',

      m('.flex-centered',
        m('figure.avatar.avatar-xl.avatar-svg', home),

        m('div', {
          style: `
            width: 6rem;
            border-top: 2px dashed hsla(256, 60%, 82%, 1);
            align-self: center;
            line-height: 0;
          `
        },
          m('span.bg-gray.p-1', { style: `border: 1px solid #ccc;` }, "Allow?")
        ),

        options.client.meta.avatar
          ? m('figure.img-xl', m('img', { src: options.client.meta.avatar }))
          : m('figure.avatar.avatar-xl.avatar-svg', question)
      ),

      m('h1.h3', { style: `margin: 1.5rem` }, options.title),
    ),

    m('form[method=post].body-content.padding.mw-sm.centered.text-center',
      m('input[type=hidden][name=transaction_id]', { value: options.transaction_id }),
      ...children
    )
  )
}
